(function(apiKey){
    (function(p,e,n,d,o){var v,w,x,y,z;o=p[d]=p[d]||{};o._q=[];
    v=['initialize','identify','updateOptions','pageLoad','track'];for(w=0,x=v.length;w<x;++w)(function(m){
        o[m]=o[m]||function(){o._q[m===v[0]?'unshift':'push']([m].concat([].slice.call(arguments,0)));};})(v[w]);
        y=e.createElement(n);y.async=!0;y.src='https://cdn.pendo.io/agent/static/'+apiKey+'/pendo.js';
        z=e.getElementsByTagName(n)[0];z.parentNode.insertBefore(y,z);})(window,document,'script','pendo')              
})('6e519408-cd03-44fc-705e-9fd669e6d87a');

define('lib/Podio.Tracking.Pendo',['require','lib/Podio.Utils','lib/Podio.Config'],function(require) {
    var podioUtils = require('lib/Podio.Utils');
    var podioConfig = require('lib/Podio.Config');
    var pendoData = {
        visitor_id: '',
        timezone: '',
        environment: ''
    };

    function setPendoInitialData() {
        if(podioConfig) {
            if (podioConfig.environment === 'staging' || podioConfig.environment === 'production') {
                pendoData.environment = podioConfig.environment;
                if(podioConfig.user) {
                    pendoData.visitor_id = ((podioConfig.environment === 'staging') ? 'stage_' : 'prod_') + podioConfig.user.user_id;
                    pendoData.timezone = podioConfig.user.timezone;
                }
            }
            else {
                pendoData.environment = 'development'
                if(podioConfig.user) {
                    pendoData.visitor_id = 'dev_' + podioConfig.user.user_id;
                    pendoData.timezone = podioConfig.user.timezone;
                }
            }
        }
    }

    function initializePendoTracking() {
        setPendoInitialData();
        if (window.pendo) {
            window.pendo.initialize({
                visitor: {
                    id: pendoData.visitor_id,
                    timezone: pendoData.timezone
                },
                account: {
                    id: pendoData.environment,
                    name: "environment"
                }
            });
        }
    }

    initializePendoTracking();

    function trackOnDisableNewUI() {
        pendo.track("new_ui_disabled", {
          message: "New UI disabled"
        });
        return;
    }
    var disable_new_ui_link = document.querySelector('#disable_new_ui');
    if (disable_new_ui_link) {
        disable_new_ui_link.addEventListener('click', trackOnDisableNewUI);
    }

});


